import CallServer from '../../api/CallServerV2';
export async function fetchOperations () {
    return await CallServer({
        endpoint: '/admin/get_operations',
        retryIfFailed: true,
        isGet: true
    })
} 

export async function fetchOperation (operation_id) {
    return await CallServer({
        params: {
            operation_id: operation_id
        },
        endpoint: '/admin/get_operation',
        isGet: true
    })
}

// polls an operation until it is completed or failed, giving up after maxAttempts
export async function waitForOperation (operation_id, interval = 5000, maxAttempts = 120) {
    for(let attempt = 0; attempt < maxAttempts; attempt++){
        const response = await fetchOperation(operation_id)
        if(!response.success || ['completed', 'failed'].includes(response.data?.state))
            return response
        await new Promise(resolve => setTimeout(resolve, interval))
    }
    return { success: false, error: 'timeout' }
}
